import servicioReducer from './servicioReducer';

export default servicioReducer;